import { render, staticRenderFns } from "./FattureLavorazione.vue?vue&type=template&id=96145dec"
import script from "./FattureLavorazione.vue?vue&type=script&lang=js"
export * from "./FattureLavorazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports